import "./HintCallout.css";

/**
 * Caixa de dica inline (não popover) para destacar uma orientação dentro de
 * uma tela ou modal. Ver HintTooltip para o padrão de popover no hover.
 *
 * Sem as props opcionais é a dica neutra de sempre. Para um aviso que pede ação:
 * - tone="warning" pinta a caixa de âmbar, o mesmo tom dos alertas de atenção do tema;
 * - title vira a linha em destaque acima do texto;
 * - action fica à direita no computador e desce para baixo do texto no celular.
 */
const HintCallout = ({ icon = "fa-lightbulb", tone, title, action, children }) => {
    const className = ["hint-callout", tone && `hint-callout--${tone}`, action && "hint-callout--with-action"]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={className}>
            <i className={`fas ${icon} hint-callout__icon`} aria-hidden="true"></i>
            <div className="hint-callout__content">
                {title && <strong className="hint-callout__title">{title}</strong>}
                {children && <p className="hint-callout__text">{children}</p>}
            </div>
            {action && <div className="hint-callout__action">{action}</div>}
        </div>
    );
};

export default HintCallout;
